module.exports = __webpack_public_path__ + "assets/img/start_securing_your_apps.1fa7dd35.svg";